export function getAddressValidationEndpoint(): string {
    return '/address/validate';
}
export function getAddressValidationAutocompleteEndpoint(): string {
    return '/address/autocomplete';
}
